exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-58a838f4] .md-menu-content.md-select-menu {\n  width: 150px;\n}\n.modal-container[data-v-58a838f4] {\n  max-width: 600px;\n}\n[data-v-58a838f4] .md-switch .md-switch-label {\n  color: #3c4858 !important;\n}\n", ""]);

// exports
